module.exports = __webpack_public_path__ + "static/media/share.1894418a.png";